import { render, staticRenderFns } from "./DeleteUser.vue?vue&type=template&id=fbaa6404&scoped=true"
import script from "./DeleteUser.vue?vue&type=script&lang=js"
export * from "./DeleteUser.vue?vue&type=script&lang=js"
import style0 from "./DeleteUser.vue?vue&type=style&index=0&id=fbaa6404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbaa6404",
  null
  
)

export default component.exports